<template>
  <div class="login-page">
    <div class="login-shell">
      <aside class="login-brand-panel">
        <div class="brand-decoration decoration-one"></div>
        <div class="brand-decoration decoration-two"></div>
        <div class="brand-copy">
          <span class="brand-eyebrow">Station Dashboard</span>
          <h1>One workspace for cleaner operations.</h1>
          <p>
            Monitor employee, contract, branch, dan operational report dalam
            satu dashboard terintegrasi.
          </p>
          <div class="brand-features">
            <span><i class="ti ti-check"></i> Secure access</span>
            <span><i class="ti ti-check"></i> Centralized data</span>
          </div>
        </div>
        <small class="brand-footer">Tukang Bersih Indonesia</small>
      </aside>

      <main class="login-form-panel">
        <div class="logo-wrapper">
          <img
            src="../../assets/img/logo.ecleaning.svg"
            class="company-logo"
            alt="e-Clean by ecoCare Cleaning"
          />
        </div>
      <div class="login-show" v-if="enable_form == 'auth'">
        <span class="form-eyebrow">Welcome back</span>
        <h2>Login to your account</h2>
        <p class="form-description">
          Masukkan akses dan akun Anda untuk melanjutkan.
        </p>
        <div class="install-app-card" v-if="showInstallApp">
          <div class="install-app-copy">
            <i class="ti ti-mobile"></i>
            <div>
              <strong>Pasang Station Dashboard</strong>
              <small>Akses lebih cepat langsung dari home screen.</small>
            </div>
          </div>
          <button type="button" class="install-app-button" @click="installApp">
            <i class="ti ti-download"></i> Install App
          </button>
          <small class="install-app-guide" v-if="showInstallGuide">
            {{ installGuide }}
          </small>
        </div>
        <form @submit="SubmitLogin">
          <div class="form-group">
            <label>Privileges Group Access</label>
            <select class="form-control" v-model="model.id_privileges">
              <option value="">-- Choose One --</option>
              <option value="10">Root</option>
              <option value="18">Control Report</option>
              <option value="14">Client Station</option>
              <option value="11">Operation Manager</option>
              <option value="12">Supervisor</option>
              <option value="13">Leader</option>
              <option value="15">Hrd</option>
              <!-- last request revisi dituker, sales = 17 dan sales manager = 16 -->
              <option value="16">Sales Manager</option>
              <option value="17">Sales</option>
              <option value="19">Admin (Executive)</option>
              <option value="20">Branch Manager</option>
              <option value="21">Hrd Nasional</option>
            </select>
            <small class="form-msg text-danger" v-if="error.id_privileges">{{
              error.id_privileges[0]
            }}</small>
          </div>
          <div class="form-group">
            <label>Email Address</label>
            <input
              type="email"
              v-model="model.email"
              class="form-control input_user"
              value=""
              placeholder="...."
            />
            <small class="form-msg text-danger" v-if="error.email">{{
              error.email[0]
            }}</small>
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              type="password"
              v-model="model.password"
              class="form-control input_pass"
              value=""
              placeholder="...."
            />
            <small class="form-msg text-danger" v-if="error.password">{{
              error.password[0]
            }}</small>
          </div>
          <button type="submit" class="btn btn-primary btn-block login-button">
            <vue-loaders-ball-beat
              color="white"
              scale=".35"
              v-if="$store.state.loading.status"
            ></vue-loaders-ball-beat>
            <span v-else>CONTINUE </span>
          </button>
        </form>
      </div>
      <div class="login-show" v-if="enable_form == 'branch'">
        <span class="form-eyebrow">Workspace access</span>
        <h2>Choose Branch Station</h2>
        <p class="form-description">
            Branch options can change the data transfer between one branch and
            another
            by selecting one of the following, all contract data,
            employee, client and others can be displayed.
        </p>
        <div class="form-group">
          <label>Branch Station</label>
          <select class="form-control" v-model="model.index_branch">
            <option value="">-- Choose One --</option>
            <option
              v-for="(items, idx) in model_branch"
              :key="idx"
              :value="idx"
            >
              {{ items.name }}
            </option>
          </select>
          <small class="text-danger" v-if="msg_validate_submit !== ''">{{
            msg_validate_submit
          }}</small>
        </div>
        <button
          type="submit"
          class="btn btn-primary btn-block login-button"
          @click="ContinueLogin()"
        >
          <vue-loaders-ball-beat
            color="white"
            scale=".35"
            v-if="$store.state.loading.status"
          ></vue-loaders-ball-beat>
          <span v-else>CONTINUE LOGIN </span>
        </button>
      </div>
      </main>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import Password from 'vue-password-strength-meter';
// import axios from 'axios';

export default {
  components: {
    // Password
  },
  data() {
    return {
      isEnableFormReset: false,
      isEnableForgot: false,
      isEnableVerificationCode: false,
      enable_form: "auth",
      model_privileges: [],
      model: {
        email: "",
        password: "",
        id_privileges: "",
        index_branch: "",
        password_confirmation: "",
        code1: "",
        code2: "",
        code3: "",
        code4: "",
      },
      msg_validate_submit: "",
      deferredInstallPrompt: null,
      showInstallApp: false,
      showInstallGuide: false,
      installGuide: "",

      model_branch: [],
      model_client_access: [],
      model_auth: {},
    };
  },

  computed: {
    ...mapState("authenticate", {
      error: (state) => state.error,
    }),
  },

  mounted() {
    this.showInstallApp = !this.isAppInstalled();
    window.addEventListener("beforeinstallprompt", this.handleInstallPrompt);
    window.addEventListener("appinstalled", this.handleAppInstalled);
  },

  beforeDestroy() {
    window.removeEventListener("beforeinstallprompt", this.handleInstallPrompt);
    window.removeEventListener("appinstalled", this.handleAppInstalled);
  },

  methods: {
    isAppInstalled() {
      return window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true;
    },
    handleInstallPrompt(event) {
      event.preventDefault();
      this.deferredInstallPrompt = event;
      this.showInstallApp = true;
      this.showInstallGuide = false;
    },
    handleAppInstalled() {
      this.deferredInstallPrompt = null;
      this.showInstallApp = false;
      this.showInstallGuide = false;
    },
    async installApp() {
      if (this.deferredInstallPrompt) {
        this.deferredInstallPrompt.prompt();
        await this.deferredInstallPrompt.userChoice;
        this.deferredInstallPrompt = null;
        return;
      }

      const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
      this.installGuide = isIos
        ? "Di Safari, tekan Share lalu pilih Add to Home Screen."
        : "Buka menu browser (tiga titik), lalu pilih Install app atau Add to Home screen.";
      this.showInstallGuide = true;
    },
    async ContinueLogin(initial) {
      // console.log(this.model_branch);
      if (!initial) {
        if (this.model.index_branch !== "") {
          let model = this.model_branch[this.model.index_branch];
          
          localStorage.setItem("userBranchId", model.id);
          localStorage.setItem("userBranchName", model.name);
          localStorage.setItem("userBranchCode", model.branch_code);
          localStorage.setItem(
            "userBranchData",
            JSON.stringify(this.model_branch)
          );
          localStorage.setItem("data_regencies", model.group_regencies);
          localStorage.setItem("id_provinces", model.id_provinces);
          localStorage.setItem("provinces_name", model.nama_provinsi);
        } else {
          this.msg_validate_submit = "Please choose branch!";
          return;
        }
      }

      if (initial == "user_client") {
        // console.log(this.model.index_branch);

        let model = this.model_branch[0];
        localStorage.setItem("userBranchId", model.id);
        localStorage.setItem("userBranchName", model.name);
        localStorage.setItem("data_regencies", model.group_regencies);
        localStorage.setItem("id_provinces", model.id_provinces);
        localStorage.setItem("provinces_name", model.nama_provinsi);

        localStorage.setItem(
          "userBranchData",
          JSON.stringify(this.model_branch)
        );

        localStorage.setItem(
          "user-client",
          JSON.stringify(this.model_client_access)
        );

        localStorage.setItem(
          "user-clien_id",
          this.model_client_access[0].client_id
        );
      }
      // console.log("user_client ga ke log")
      localStorage.setItem("user-login", "true");
      localStorage.setItem("app-session", this.model_auth.app_session);
      localStorage.setItem("userid", this.model_auth.userid);
      localStorage.setItem("jwt-token", this.model_auth.token);
      window.location.reload();
    },
    InitialInput(next_id, val) {
      if (val !== "") {
        document.getElementById(next_id).focus();
      }
    },

    async SubmitLogin(e) {
      e.preventDefault();
      let res = await this.$store.dispatch("authenticate/login", this.model);
      if (res) {
        this.model_auth = res.auth;
        this.model_branch = res.data_branch;

        if (res.form == "direct") {
          this.ContinueLogin("direct");
        } else {
          if (res.form == "user_client") {
            this.model_client_access = res.client_access;
            this.ContinueLogin("user_client");
          } else {
            this.enable_form = res.form;
          }
        }
      }
    },
    async NewPassword(e) {
      e.preventDefault();
      let res = await this.$store.dispatch("authenticate/reset", this.model);
      if (res && res.result == "true") {
        this.$store.dispatch("authenticate/login", this.model);
      }
    },
    async RecoveryPassword(e) {
      e.preventDefault();
      if (!this.isEnableVerificationCode) {
        let res = await this.$store.dispatch("authenticate/forgot", this.model);
        if (res && res.result == "true") {
          alert(res.msg);
          this.isEnableVerificationCode = true;
          setTimeout(() => {
            document.getElementById("code1").focus();
          }, 300);
        }
      } else {
        let res = await this.$store.dispatch("authenticate/check", this.model);
        if (res && res.result == "true") {
          this.isEnableFormReset = true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 40px 24px;
  background:
    radial-gradient(circle at 10% 15%, rgba(10, 174, 191, .12), transparent 28%),
    radial-gradient(circle at 92% 85%, rgba(16, 60, 130, .1), transparent 30%),
    #f5f8fc;
}

.login-shell {
  display: grid;
  grid-template-columns: minmax(320px, .9fr) minmax(430px, 1.1fr);
  width: 100%;
  max-width: 1080px;
  min-height: 620px;
  overflow: hidden;
  border: 1px solid rgba(222, 228, 235, .8);
  border-radius: 22px;
  background: #fff;
  box-shadow: 0 24px 70px rgba(28, 45, 75, .16);
}

.login-brand-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 62px 54px;
  color: #fff;
  background: linear-gradient(145deg, #103c82 0%, #087da2 56%, #0aaebf 100%);
}

.brand-copy { position: relative; z-index: 2; }
.brand-eyebrow, .form-eyebrow { font-size: 11px; font-weight: 700; letter-spacing: 1.3px; text-transform: uppercase; }
.brand-eyebrow { color: #a7f3d0; }
.brand-copy h1 { max-width: 420px; margin: 14px 0 18px; color: #fff; font-size: 36px; font-weight: 700; line-height: 1.2; }
.brand-copy p { max-width: 430px; margin: 0; color: rgba(255,255,255,.78); font-size: 14px; line-height: 1.75; }
.brand-features { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 30px; }
.brand-features span { padding: 8px 12px; border: 1px solid rgba(255,255,255,.2); border-radius: 20px; background: rgba(255,255,255,.1); font-size: 11px; font-weight: 600; }
.brand-features i { margin-right: 5px; color: #a7f3d0; }
.brand-footer { position: absolute; bottom: 30px; z-index: 2; color: rgba(255,255,255,.55); }
.brand-decoration { position: absolute; border: 1px solid rgba(255,255,255,.13); border-radius: 50%; }
.decoration-one { top: -130px; right: -100px; width: 360px; height: 360px; }
.decoration-two { right: 45px; bottom: -180px; width: 310px; height: 310px; background: rgba(255,255,255,.04); }

.login-form-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 54px 72px;
  background: #fff;
}

.logo-wrapper { margin-bottom: 38px; }
.company-logo { display: block; width: 230px; height: auto; }
.login-show { width: 100%; color: #364152; }
.form-eyebrow { color: #0aaebf; }
.login-show h2 { margin: 8px 0 8px; color: #233044; font-size: 27px; font-weight: 700; }
.form-description { margin: 0 0 28px; color: #7a8492; line-height: 1.6; }
.install-app-card { display: none; margin: -8px 0 24px; padding: 14px; border: 1px solid rgba(10,174,191,.22); border-radius: 12px; background: linear-gradient(135deg, rgba(10,174,191,.07), rgba(23,105,210,.05)); }
.install-app-copy { display: flex; align-items: center; gap: 10px; }
.install-app-copy > i { display: flex; align-items: center; justify-content: center; flex: 0 0 36px; width: 36px; height: 36px; border-radius: 10px; color: #fff; background: linear-gradient(135deg, #1769d2, #0aaebf); font-size: 17px; }
.install-app-copy strong, .install-app-copy small { display: block; }
.install-app-copy strong { color: #233044; font-size: 12px; }
.install-app-copy small { margin-top: 2px; color: #7a8492; font-size: 10px; }
.install-app-button { width: 100%; min-height: 38px; margin-top: 11px; border: 1px solid rgba(10,174,191,.35); border-radius: 8px; color: #087da2; background: #fff; font-size: 11px; font-weight: 700; transition: background .2s, color .2s, transform .2s; }
.install-app-button:hover { color: #fff; background: #0aaebf; transform: translateY(-1px); }
.install-app-button i { margin-right: 5px; }
.install-app-guide { display: block; margin-top: 10px; color: #536075; font-size: 10px; line-height: 1.5; }
.form-group { margin-bottom: 18px; }
.form-group label { margin-bottom: 7px; color: #536075; font-size: 12px; font-weight: 700; }
.form-control { height: 46px; border: 1px solid #dfe5ec; border-radius: 9px; color: #364152; background: #fbfcfe; transition: border-color .2s, box-shadow .2s; }
.form-control:focus { border-color: #0aaebf; background: #fff; box-shadow: 0 0 0 3px rgba(10,174,191,.12); }
.login-button { min-height: 48px; margin-top: 8px; border: 0; border-radius: 9px; background: linear-gradient(100deg, #1769d2, #0aaebf); font-size: 12px; font-weight: 700; letter-spacing: .4px; box-shadow: 0 8px 20px rgba(23,105,210,.22); }
.login-button:hover { transform: translateY(-1px); box-shadow: 0 11px 24px rgba(23,105,210,.28); }
.form-msg { display: block; margin-top: 5px; }

@media (max-width: 900px) {
  .login-shell { grid-template-columns: 1fr; max-width: 600px; }
  .login-brand-panel { min-height: 260px; padding: 42px; }
  .brand-copy h1 { font-size: 29px; }
  .brand-footer { display: none; }
  .login-form-panel { padding: 48px 54px; }
}

@media (max-width: 575px) {
  .login-page { align-items: flex-start; padding: 18px 12px; }
  .login-shell { min-height: auto; border-radius: 16px; }
  .login-brand-panel { min-height: 210px; padding: 30px 24px; }
  .brand-copy h1 { margin: 10px 0 12px; font-size: 24px; }
  .brand-copy p { font-size: 12px; line-height: 1.55; }
  .brand-features { margin-top: 18px; }
  .login-form-panel { padding: 34px 24px 38px; }
  .logo-wrapper { margin-bottom: 28px; }
  .company-logo { width: 200px; }
  .login-show h2 { font-size: 23px; }
  .install-app-card { display: block; }
}
</style>
